import {taskList, projectCreate, unassociatedList, projectShow, projectUpdate } from '@/api/task-project.js'
export const Project = {
  data () {
    return {
      pageLimitOPtion: [
        {
          name: 5,
          value: 5
        },
        {
          name: 10,
          value: 10
        },
        {
          name: 20,
          value: 20
        }
      ],
      pageLimitSet: 5,
      meta: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta_template: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta_task: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1,
        limit: 10
      },
      ListOfTask: [],
      ListOfLiveTask: [],
      all_task_details: [
        {
          id: '',
          name : '',
          due_date: '',
          task_priority_id : '',
          task_status_id: '',
          comments: '',
          details: '',
          is_tracking_active: false,
          clientObserver:[],
          clientParticipant:[],
          clientResponsiblePerson:[],
          userObserver:[],
          userParticipant:[],
          userResponsiblePerson:[],
          timeSchedules:[],
          projectStatusTag: '',
          checklist:[],
          is_template: false,
          ResponsiblePersonData: [],
          ParticipantPersonData: [],
          observerPersonData: [],
          selectedSubTaskData: [],
          selectedCRMData: [],
          reminderTime: [],
          from_time: '',
          to_time: '',
          checklistRows: [],
          projects: [],
          tags: [],
          subtask: [],
          leads: [],
          reminder: [],
          configdateTimePicker: {
            enableTime: true,
            enableSeconds: true,
            noCalendar: false,
            maxDate: ''
          }
        }
      ],
      projectData: {
        name: '',
        details: '',
        due_date: '',
        liveTask: [],
        attachLiveTask: [],
        userProjectMember: [],
        clientProjectMember: [],
        projectStatusTag: []
      },
      projectDetailsData: [],
      taskRow: '',
      memberData: [],
      typeOfPerson:'',
      popupActive: false,
      liveTaskImportData: [],
      projectUpdateId: ''
    }
  },
  methods: {
    addTaskStatus () {
      this.allTaskStatus.push({
        id: this.allTaskStatus.length + 1,
        name: this.statusname
      })
      this.statusname = ''
      this.statusActive = false
    },
    closeStatus (index) {
      this.allTaskStatus.splice(index, 1)
    },
    addNewTask () {
      this.all_task_details.push({
        id: '',
        name : '',
        due_date: '',
        task_priority_id : '',
        task_status_id: '',
        comments: '',
        details: '',
        clientObserver:[],
        clientParticipant:[],
        clientResponsiblePerson:[],
        userObserver:[],
        userParticipant:[],
        userResponsiblePerson:[],
        timeSchedules:[],
        projectStatusTag: '',
        checklist:[],
        is_template: false,
        ResponsiblePersonData: [],
        ParticipantPersonData: [],
        observerPersonData: [],
        selectedSubTaskData: [],
        selectedCRMData: [],
        reminderTime: [],
        from_time: '',
        to_time: '',
        is_tracking_active: false,
        checklistRows: [],
        tags: [],
        subtask: [],
        leads: [],
        reminder: [],
        configdateTimePicker: {
          enableTime: true,
          enableSeconds: true,
          noCalendar: false,
          maxDate: ''
        }
      })
    },
    removeCard (index) {
      if (this.all_task_details.length === 1) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Sorry! you can\'t remove this task',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        this.all_task_details.splice(index, 1)
      }
    },
    async fetchTask (query) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        const { data } = await taskList(query)
        console.log(data.data)
        const table = data.data.taskTemplates
        this.meta_template = data.data.meta_template
        this.meta_task = data.data.meta_task
        table.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        this.$vs.loading.close()
        this.ListOfTask = table
        const liveTable = data.data.tasks
        liveTable.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        this.ListOfLiveTask = liveTable
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    },
    fetchLiveTask (query) {
      unassociatedList(this.customer_id, query)
        .then((res) => {
          this.meta = res.data.data.meta
          console.log(res.data.data)
          this.liveTaskImportData = res.data.data.tasks
        })
        .catch((e) => {
          console.log(e)
        })
    },   
    async loadMoreTemplate (showType) {
      if (showType === 'plus') {
        this.meta_template.current_page = this.meta_template.current_page + 1
      } else {
        this.meta_template.current_page = this.meta_template.current_page - 1
      }
      this.fetchTask(this.meta_template.current_page)
    },
    async loadMoreTask (showType) {
      if (showType === 'plus') {
        this.meta.current_page = this.meta.current_page + 1
      } else {
        this.meta.current_page = this.meta.current_page - 1
      }
      this.fetchLiveTask(this.meta.current_page)
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    addMoreUserProject (data, index) {
      this.popupActive = true 
      this.typeOfPerson = data
      this.taskRow = index
    },
    closeSelectedProject (data, index) {
      if (data === 'Member') {
        this.memberData.splice(index, 1)
      } else if (data === 'ResponsiblePerson') {
        this.all_task_details[this.taskRow].ResponsiblePersonData.splice(index, 1)
      } else if (data === 'ParticipantPerson') {
        this.all_task_details[this.taskRow].ParticipantPersonData.splice(index, 1)
      } else if (data === 'subTask') {
        this.all_task_details[this.taskRow].selectedSubTaskData.splice(index, 1)
      } else if (data === 'CRM') {
        this.all_task_details[this.taskRow].selectedCRMData.splice(index, 1)
      } else {
        this.all_task_details[this.taskRow].observerPersonData.splice(index, 1)
      }
    },
    addChecklistProject (index) {
      this.all_task_details[index].checklistRows.push({
        showTextBox: [],
        items: [],
        itemStatusCal: []
      })
    },
    removeChecklistProject (index, index3) {
      this.all_task_details[index].checklistRows.splice(index3, 1)
    },
    submitItemProject (rowIndex, index3, data) { 
      for (let index = 0; index < data.showTextBox.length; index++) {
        if (data.showTextBox[index].itemName !== '') {
          this.all_task_details[rowIndex].checklistRows[index3].items.push({
            todo: data.showTextBox[index].itemName,
            is_completed: false
          })
        }
      }
      for (let index = 0; index < data.showTextBox.length; index++) {
        data.showTextBox[index].itemName = ''
      }
      this.all_task_details[rowIndex].checklistRows[index3].showTextBox = []
    },
    deleteItemProject (rowIndex, index3, index) {
      if (this.all_task_details[rowIndex].checklist.length !== 0) {
        if (this.all_task_details[rowIndex].checklist[index3].todos.length === 1) {
          this.all_task_details[rowIndex].checklist.splice(index, 1)
        } else {
          if (this.all_task_details[rowIndex].checklist[index3].todos[index].is_completed === true) {
            this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length - 1
          }
          this.all_task_details[rowIndex].checklist[index3].todos.splice(index, 1)
        }
      }
    },
    deleteItemProjectFromCheck (rowIndex, index3, index) {
      if (this.all_task_details[rowIndex].checklistRows.length !== 0) {
        if (this.all_task_details[rowIndex].checklistRows[index3].items.length === 1) {
          this.all_task_details[rowIndex].checklistRows.splice(index, 1)
        } else {
          if (this.all_task_details[rowIndex].checklistRows[index3].items[index].is_completed === true) {
            this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length - 1
          }
          this.all_task_details[rowIndex].checklistRows[index3].items.splice(index, 1)
        }
      }
    },
    changeStatusProject (rowIndex, index3, index) {
      if (this.all_task_details[rowIndex].checklist.length !== 0) {
        if (this.all_task_details[rowIndex].checklist[index3].todos[index].is_completed === true) {
          this.all_task_details[rowIndex].checklist[index3].todos[index].is_completed = true
          this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length + 1
        } else {
          this.all_task_details[rowIndex].checklist[index3].todos[index].is_completed = false
          this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length - 1
        }
      }
      
    },
    changeStatusProjectFromCheck (rowIndex, index3, index) {
      if (this.all_task_details[rowIndex].checklistRows.length !== 0) {
        if (this.all_task_details[rowIndex].checklistRows[index3].items[index].is_completed === true) {
          this.all_task_details[rowIndex].checklistRows[index3].items[index].is_completed = true
          this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length + 1
        } else {
          this.all_task_details[rowIndex].checklistRows[index3].items[index].is_completed = false
          this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length - 1 
        }
      }
      
    },
    addUserProject () {
      const arr = []
      for (let i = 0; i < this.selectedUsers.length; i++) {
        arr.push({
          first_name: this.selectedUsers[i].first_name,
          last_name: this.selectedUsers[i].last_name,
          user_type: this.selectedUsers[i].user_type,
          users_id: this.selectedUsers[i].users_id
        })
      }
      for (let i = 0; i < this.selectedClients.length; i++) {
        arr.push({
          first_name: this.selectedClients[i].first_name,
          last_name: this.selectedClients[i].last_name,
          user_type: this.selectedClients[i].user_type,
          users_id: this.selectedClients[i].client_users_id
        })
      }
      if (this.typeOfPerson === 'Member') {
        const res2 = this.memberData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.memberData = this.memberData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.memberData = arr.concat(this.memberData)
      } else if (this.typeOfPerson === 'ResponsiblePerson') {
        const res2 = this.all_task_details[this.taskRow].ResponsiblePersonData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.all_task_details[this.taskRow].ResponsiblePersonData = this.all_task_details[this.taskRow].ResponsiblePersonData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].ResponsiblePersonData = arr.concat(this.all_task_details[this.taskRow].ResponsiblePersonData)
      } else if (this.typeOfPerson === 'ParticipantPerson') {
        const res2 = this.all_task_details[this.taskRow].ParticipantPersonData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.all_task_details[this.taskRow].ParticipantPersonData = this.all_task_details[this.taskRow].ParticipantPersonData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].ParticipantPersonData = arr.concat(this.all_task_details[this.taskRow].ParticipantPersonData)
      } else {
        const res2 = this.all_task_details[this.taskRow].observerPersonData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.all_task_details[this.taskRow].observerPersonData = this.all_task_details[this.taskRow].observerPersonData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].observerPersonData = arr.concat(this.all_task_details[this.taskRow].observerPersonData)
      }
      this.selectedUsers = []
      this.selectedClients = []
      this.popupActive = false 
    },
    submitProject () {
      console.log(this.all_task_details)
      for (let index = 0; index < this.all_task_details.length; index++) {
        if (this.all_task_details[index].id === null || this.all_task_details[index].id === '') {
          if (this.all_task_details[index].ParticipantPersonData.length !== 0 && this.all_task_details[index].observerPersonData.length !== 0 && this.all_task_details[index].from_time !== '' && this.all_task_details[index].to_time !== '') {
            if (this.all_task_details[index].is_template === '1' || this.all_task_details[index].is_template === true) {
              this.all_task_details[index].is_template = true
            } else {
              this.all_task_details[index].is_template = false
            }
            if (this.all_task_details[index].ResponsiblePersonData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].ResponsiblePersonData.length; i++) {
                if ('user_type' in this.all_task_details[index].ResponsiblePersonData[i]) {
                  if (this.all_task_details[index].ResponsiblePersonData[i].user_type === 0) {
                    this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id) 
                  } else {
                    this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id)
                  } 
                } 
                if ('pivot' in this.all_task_details[index].ResponsiblePersonData[i]) {
                  if (this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_type === 0) {
                    this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id) 
                  } else {
                    this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id)
                  }  
                }
              }
            }

            if (this.all_task_details[index].ParticipantPersonData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].ParticipantPersonData.length; i++) {
                if ('user_type' in this.all_task_details[index].ParticipantPersonData[i]) {
                  if (this.all_task_details[index].ParticipantPersonData[i].user_type === 0) {
                    this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id) 
                  } else {
                    this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id)
                  }  
                } 
                if ('pivot' in this.all_task_details[index].ParticipantPersonData[i]) {
                  if (this.all_task_details[index].ParticipantPersonData[i].pivot.participants_type === 0) {
                    this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id) 
                  } else {
                    this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id)
                  }  
                }
              }
            }
       
            if (this.all_task_details[index].observerPersonData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].observerPersonData.length; i++) {
                if ('user_type' in this.all_task_details[index].observerPersonData[i]) {
                  if (this.all_task_details[index].observerPersonData[i].user_type === 0) {
                    this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].users_id) 
                  } else {
                    this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].users_id)
                  }  
                } 
                if ('pivot' in this.all_task_details[index].observerPersonData[i]) {
                  if (this.all_task_details[index].observerPersonData[i].pivot.observers_type === 0) {
                    this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id) 
                  } else {
                    this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id)
                  }  
                }
              }
            }
            if (this.all_task_details[index].selectedSubTaskData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].selectedSubTaskData.length; i++) {
                this.all_task_details[index].subtask.push(this.all_task_details[index].selectedSubTaskData[i].id) 
              }
            }
            if (this.all_task_details[index].selectedCRMData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].selectedCRMData.length; i++) {
                this.all_task_details[index].leads.push(this.all_task_details[index].selectedCRMData[i].leads_id) 
              }
            }
            if (this.all_task_details[index].reminderTime.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].reminderTime.length; i++) {
                this.all_task_details[index].reminder.push({
                  reminder_type: 1,
                  reminder_time: this.all_task_details[index].reminderTime[i].reminder_time
                }) 
              }
            }

            if (this.all_task_details[index].checklistRows.length !== 0 || this.all_task_details[index].checklist.length !== 0) {
              for (let index2 = 0; index2 < this.all_task_details[index].checklist.length; index2++) {
                if ('todos' in this.all_task_details[index].checklist[index2]) {
                  if (this.all_task_details[index].checklist[index2].todos.length === 0) this.all_task_details[index].checklist.splice(index2, 1)
                }
              }
              for (let i = 0; i < this.all_task_details[index].checklistRows.length; i++) {
                this.all_task_details[index].checklist.push({
                  name: `checklist${ i + 1}`,
                  todos: this.all_task_details[index].checklistRows[i].items
                })
      
              }
            }
            this.projectData.liveTask.push(this.all_task_details[index]) 
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: 'All fiels are required',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
            throw new Error('Stop script')
          }
        } else {
          this.projectData.attachLiveTask.push({
            id: this.all_task_details[index].id,
            project_status_name: this.all_task_details[index].projectStatusTag

          })
        }
      }

      if (this.memberData.length !== 0) {
        for (let i = 0; i < this.memberData.length; i++) {
          if (this.memberData[i].user_type === 0) {
            this.projectData.userProjectMember.push(this.memberData[i].users_id) 
          } else {
            this.projectData.clientProjectMember.push(this.memberData[i].users_id)
          }  
        }
      }
        
      for (let i = 0; i < this.allTaskStatus.length; i++) {
        this.projectData.projectStatusTag.push({
          name: this.allTaskStatus[i].name,
          weighted_order_id: i + 1
        }) 
      }
      this.projectData.liveTask.forEach(e => { delete e.ParticipantPersonData })
      this.projectData.liveTask.forEach(e => { delete e.observerPersonData })
      this.projectData.liveTask.forEach(e => { delete e.checklistRows })
      console.log(this.projectData)
      this.createProject(this.projectData)
    },
    createProject (data) {       
      projectCreate(this.customer_id, data)
        .then((res) => {
          this.$vs.notify({
            title: 'Success',
            text: 'Project Created Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.clearProjectData()
         
        })
        .catch((e) => {
          console.log(e)
          this.clearProjectData()
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },
    updateProject () {
      for (let index = 0; index < this.all_task_details.length; index++) {
        if (this.all_task_details[index].id === null || this.all_task_details[index].id === '') {
          if (this.all_task_details[index].ParticipantPersonData.length !== 0 && this.all_task_details[index].observerPersonData.length !== 0 && this.all_task_details[index].from_time && this.all_task_details[index].to_time) {
            if (this.all_task_details[index].is_template === '1' || this.all_task_details[index].is_template === true) {
              this.all_task_details[index].is_template = true
            } else {
              this.all_task_details[index].is_template = false
            }

            if (this.all_task_details[index].ResponsiblePersonData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].ResponsiblePersonData.length; i++) {
                if ('user_type' in this.all_task_details[index].ResponsiblePersonData[i]) {
                  if (this.all_task_details[index].ResponsiblePersonData[i].user_type === 0) {
                    this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id) 
                  } else {
                    this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id)
                  } 
                } 
                if ('pivot' in this.all_task_details[index].ResponsiblePersonData[i]) {
                  if (this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_type === 0) {
                    this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id) 
                  } else {
                    this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id)
                  }  
                }
              }
            }

            if (this.all_task_details[index].ParticipantPersonData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].ParticipantPersonData.length; i++) {
                if ('user_type' in this.all_task_details[index].ParticipantPersonData[i]) {
                  if (this.all_task_details[index].ParticipantPersonData[i].user_type === 0) {
                    this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id) 
                  } else {
                    this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id)
                  }  
                } 
                if ('pivot' in this.all_task_details[index].ParticipantPersonData[i]) {
                  if (this.all_task_details[index].ParticipantPersonData[i].pivot.participants_type === 0) {
                    this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id) 
                  } else {
                    this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id)
                  }  
                }
              }
            }

       
            if (this.all_task_details[index].observerPersonData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].observerPersonData.length; i++) {
                if ('user_type' in this.all_task_details[index].observerPersonData[i]) {
                  if (this.all_task_details[index].observerPersonData[i].user_type === 0) {
                    this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].users_id) 
                  } else {
                    this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].users_id)
                  }  
                } 
                if ('pivot' in this.all_task_details[index].observerPersonData[i]) {
                  if (this.all_task_details[index].observerPersonData[i].pivot.observers_type === 0) {
                    this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id) 
                  } else {
                    this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id)
                  }  
                }
              }
            }
            if (this.all_task_details[index].selectedSubTaskData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].selectedSubTaskData.length; i++) {
                this.all_task_details[index].subtask.push(this.all_task_details[index].selectedSubTaskData[i].id) 
              }
            }
            if (this.all_task_details[index].selectedCRMData.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].selectedCRMData.length; i++) {
                this.all_task_details[index].leads.push(this.all_task_details[index].selectedCRMData[i].leads_id) 
              }
            }
            if (this.all_task_details[index].reminderTime.length !== 0) {
              for (let i = 0; i < this.all_task_details[index].reminderTime.length; i++) {
                this.all_task_details[index].reminder.push({
                  reminder_type: 1,
                  reminder_time: this.all_task_details[index].reminderTime[i].reminder_time
                }) 
              }
            }

            if (this.all_task_details[index].checklistRows.length !== 0 || this.all_task_details[index].checklist.length !== 0) {
              for (let index2 = 0; index2 < this.all_task_details[index].checklist.length; index2++) {
                if ('todos' in this.all_task_details[index].checklist[index2]) {
                  if (this.all_task_details[index].checklist[index2].todos.length === 0) this.all_task_details[index].checklist.splice(index2, 1)
                }
              }
              for (let i = 0; i < this.all_task_details[index].checklistRows.length; i++) {
                this.all_task_details[index].checklist.push({
                  name: `checklist${ i + 1}`,
                  todos: this.all_task_details[index].checklistRows[i].items
                })
      
              }
            }
        
            this.projectData.liveTask.push(this.all_task_details[index]) 
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: 'All fiels are required',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
            throw new Error('Stop script')
          }
        } else {
          this.projectData.attachLiveTask.push({
            id: this.all_task_details[index].id,
            project_status_name: this.all_task_details[index].projectStatusTag
          })
        } 
      }

      if (this.memberData.length !== 0) {
        for (let i = 0; i < this.memberData.length; i++) {
          if ('user_type' in this.memberData[i]) {
            if (this.memberData[i].user_type === 0) {
              this.projectData.userProjectMember.push(this.memberData[i].users_id) 
            } else {
              this.projectData.clientProjectMember.push(this.memberData[i].users_id)
            }
          } 
          if ('pivot' in this.memberData[i]) {
            if (this.memberData[i].pivot.members_type === 0) {
              this.projectData.userProjectMember.push(this.memberData[i].pivot.members_id) 
            } else {
              this.projectData.clientProjectMember.push(this.memberData[i].pivot.members_id)
            }  
          } 
        }
      }
      for (let i = 0; i < this.allTaskStatus.length; i++) {
        this.projectData.projectStatusTag.push({
          name: this.allTaskStatus[i].name,
          weighted_order_id: i + 1
        }) 
      }
      this.projectData.liveTask.forEach(e => { delete e.ParticipantPersonData })
      this.projectData.liveTask.forEach(e => { delete e.ResponsiblePersonData })
      this.projectData.liveTask.forEach(e => { delete e.observerPersonData })
      this.projectData.liveTask.forEach(e => { delete e.checklistRows })
      console.log(this.projectData)
      const payload = {
        updateField: this.projectData  
      }
      this.updateProj(payload)
    },
    updateProj (data) {       
      projectUpdate(this.customer_id, this.projectUpdateId, data)
        .then((res) => {
          this.$vs.notify({
            title: 'Success',
            text: 'Project Updated Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.clearProjectData()
         
        })
        .catch((e) => {
          console.log(e)
          this.clearProjectData()
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },
    exportToProject () {
      console.log(this.selected)
      for (let index = 0; index < this.selected.length - 1; index++) {
        this.addNewTask()
      }
      for (let index = 0; index < this.selected.length; index++) {
        if (this.selected[index].reference_id === null || this.selected[index].reference_id === '') {
          this.all_task_details[index].name = this.selected[index].name
          this.all_task_details[index].task_priority_id = this.selected[index].task_priority.id
          this.all_task_details[index].details = this.selected[index].details
          this.all_task_details[index].comments = this.selected[index].comments
          this.all_task_details[index].due_date = this.selected[index].due_date
          this.all_task_details[index].is_template = 2
          this.all_task_details[index].ResponsiblePersonData = this.selected[index].userResponsiblePerson.concat(this.selected[index].clientResponsiblePerson)
        } else {
          this.all_task_details[index].name = this.selected[index].name
          this.all_task_details[index].id = this.selected[index].id
          //this.all_task_details[index].projectStatusTag = this.selected[index].projectStatusTag.name
          this.all_task_details[index].task_priority_id = this.selected[index].task_priority.id
          this.all_task_details[index].is_template = 2
          this.all_task_details[index].details = this.selected[index].details
          this.all_task_details[index].comments = this.selected[index].comments
          this.all_task_details[index].due_date = this.selected[index].due_date
          this.all_task_details[index].from_time = this.selected[index].from_time
          this.all_task_details[index].to_time = this.selected[index].to_time
          this.all_task_details[index].is_tracking_active = this.selected[index].is_tracking_active
          this.all_task_details[index].ResponsiblePersonData = this.selected[index].userResponsiblePerson.concat(this.selected[index].clientResponsiblePerson)
          this.all_task_details[index].ParticipantPersonData = this.selected[index].userParticipant.concat(this.selected[index].clientParticipant)
          this.all_task_details[index].observerPersonData = this.selected[index].userObserver.concat(this.selected[index].clientObserver)
          this.all_task_details[index].selectedSubTaskData = this.selected[index].subtask
          this.all_task_details[index].tags = this.selected[index].tags
          this.all_task_details[index].selectedCRMData = this.selected[index].leads
          if (this.selected[index].taskReminder.length !== 0) {
            for (let index = 0; index < this.selected[index].taskReminder.length; index++) {
              this.addReminderProj()
            }
            for (let index = 0; index < this.selected[index].taskReminder.length; index++) {
              this.all_task_details[index].reminderTime[index].reminder_time = this.selected[index].taskReminder[index].reminder_time
            }
          }
          this.all_task_details[index].checklist = this.selected[index].checklist 
          this.all_task_details[index].checklist.map((row, index5) => {
            const itemStatusCal = this.all_task_details[index].checklist[index5].todos.filter(ele => {
              return ele.is_completed === true
            })
            Object.assign(row, { itemStatusCal })
          })
          console.log(this.all_task_details[index].checklist)
        } 
      }
      this.selected = []
      this.importActive = false
    },
    clearProjectData () {
      this.projectData.name = ''
      this.projectData.details = ''
      this.projectData.due_date = ''
      this.projectData.projectStatusTag = []
      this.projectData.liveTask = []
      this.projectData.attachLiveTask = []
      this.projectData.clientProjectMember = []
      this.projectData.userProjectMember = []
      this.memberData = []
      this.allTaskStatus = []
      this.all_task_details = [
        {
          name : '',
          due_date: '',
          task_priority_id : '',
          comments: '',
          details: '',
          is_tracking_active: false,
          clientObserver:[],
          clientParticipant:[],
          clientResponsiblePerson:[],
          userObserver:[],
          userParticipant:[],
          userResponsiblePerson:[],
          timeSchedules:[],
          projectStatusTag: '',
          checklist:[],
          is_template: false,
          ResponsiblePersonData: [],
          ParticipantPersonData: [],
          observerPersonData: [],
          selectedSubTaskData: [],
          selectedCRMData: [],
          reminderTime: [],
          from_time: '',
          to_time: '',
          checklistRows: [],
          tags: [],
          subtask: [],
          leads: [],
          reminder: []
        }
      ]
        
    },
    showProject (id) {
      this.projectUpdateId = id
      projectShow(id)
        .then((res) => {
          console.log(res.data.data.project)
          const fetchedProject = res.data.data.project
          this.projectData.name = fetchedProject.name
          this.projectData.due_date = fetchedProject.due_date
          this.projectData.details = fetchedProject.details
          this.allTaskStatus = fetchedProject.projectStatusTag
          for (let index = 0; index < fetchedProject.task.length - 1; index++) { 
            this.addNewTask()
          }
          for (let index = 0; index < fetchedProject.task.length; index++) {
            this.all_task_details[index].name = fetchedProject.task[index].name
            this.all_task_details[index].id = fetchedProject.task[index].id
            this.all_task_details[index].projectStatusTag = fetchedProject.task[index].projectStatusTag.name // dependancy on nilesh
            this.all_task_details[index].task_priority_id = fetchedProject.task[index].task_priority.id
            this.all_task_details[index].details = fetchedProject.task[index].details
            this.all_task_details[index].comments = fetchedProject.task[index].comments
            this.all_task_details[index].due_date = fetchedProject.task[index].due_date
            this.all_task_details[index].from_time = fetchedProject.task[index].from_time
            this.all_task_details[index].to_time = fetchedProject.task[index].to_time
            this.all_task_details[index].is_tracking_active = fetchedProject.task[index].is_tracking_active
            this.all_task_details[index].checklist = fetchedProject.task[index].checklist
            this.all_task_details[index].checklist.map((row, index5) => {
              const itemStatusCal = this.all_task_details[index].checklist[index5].todos.filter(ele => {
                return ele.is_completed === true
              })
              Object.assign(row, { itemStatusCal })
            })
            console.log(this.all_task_details[index].checklist)
            this.all_task_details[index].observerPersonData = fetchedProject.task[index].userObserver.concat(fetchedProject.task[index].clientObserver)
            this.all_task_details[index].ParticipantPersonData = fetchedProject.task[index].userParticipant.concat(fetchedProject.task[index].clientParticipant)
            this.all_task_details[index].ResponsiblePersonData = fetchedProject.task[index].userResponsiblePerson.concat(fetchedProject.task[index].clientResponsiblePerson)
            this.all_task_details[index].selectedSubTaskData = fetchedProject.task[index].subtask
            this.all_task_details[index].tags = fetchedProject.task[index].tags
            this.all_task_details[index].selectedCRMData = fetchedProject.task[index].leads
            if (fetchedProject.task[index].taskReminder.length !== 0) {
              for (let index = 0; index < fetchedProject.task[index].taskReminder.length; index++) {
                this.addReminderProj()
              }
              for (let index = 0; index < fetchedProject.task[index].taskReminder.length; index++) {
                this.all_task_details[index].reminderTime[index].reminder_time = fetchedProject.task[index].taskReminder[index].reminder_time
              }
            }   
          }
          this.memberData = fetchedProject.userProjectMember.concat(fetchedProject.clientProjectMember)
          
        })
        .catch((e) => {
          console.log(e)
        })
    },
    statusLog (event) {
      console.log(this.allTaskStatus)
      console.log(event.moved)
    },
    addProjModal (data, index) {
      this.taskRow = index
      if (data === 'subTask') {
        this.popupActiveSubTask = true
      } else {
        this.popupActiveCRM = true
      }
    },
    addProjMicData (data) {
      if (data === 'subTask') {
        const arr = []
        for (let i = 0; i < this.selectedSubTask.length; i++) {
          arr.push({
            name: this.selectedSubTask[i].name,
            id: this.selectedSubTask[i].id
          })
        }
        const res2 = this.all_task_details[this.taskRow].selectedSubTaskData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.id === o2.id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].id
            this.all_task_details[this.taskRow].selectedSubTaskData = this.all_task_details[this.taskRow].selectedSubTaskData.filter(
              (item) => item.id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].selectedSubTaskData = arr.concat(this.all_task_details[this.taskRow].selectedSubTaskData)
        this.popupActiveSubTask = false
        this.selectedSubTask = []
      } else {
        const arr = []
        for (let i = 0; i < this.selectedCRM.length; i++) {
          arr.push({
            lead_name: this.selectedCRM[i].lead_name,
            leads_id: this.selectedCRM[i].leads_id
          })
        }
        const res2 = this.all_task_details[this.taskRow].selectedCRMData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.leads_id === o2.leads_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].leads_id
            this.all_task_details[this.taskRow].selectedCRMData = this.all_task_details[this.taskRow].selectedCRMData.filter(
              (item) => item.leads_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].selectedCRMData = arr.concat(this.all_task_details[this.taskRow].selectedCRMData)
        this.popupActiveCRM = false
        this.selectedCRM = []
      }
      
    },
    addReminderProj (index) {
      this.all_task_details[index].reminderTime.push({reminder_time: ''})
    },
    removeReminderProj (index, index2) {
      this.all_task_details[index].reminderTime.splice(index2, 1)
    }
  }
}
